import { render, staticRenderFns } from "./NoticeboardModal.vue?vue&type=template&id=c7da3e24&scoped=true"
import script from "./NoticeboardModal.vue?vue&type=script&lang=js"
export * from "./NoticeboardModal.vue?vue&type=script&lang=js"
import style0 from "./NoticeboardModal.vue?vue&type=style&index=0&id=c7da3e24&prod&lang=less&scoped=true"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "c7da3e24",
  null
  
)

export default component.exports